import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorisationComponent } from './authorisation.component';

const routes: Routes = [
  {
    path: 'authorisation/:token',
    component: AuthorisationComponent,
    children: [ // verify :)
      {
        path: ':landingPage',
        component: AuthorisationComponent,
        children: [
          {
            path: ':entityId',
            component: AuthorisationComponent
          },
        ]
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthorisationRoutingModule { }
